<template>
  <section class="intro-x">
    <div class="w-full my-5">
      <back-button />
    </div>
    <div class="w-full">
      <Timeline
      :value="getStates"
      align="alternate"
      >
        <template #content="slotProps">
          <div class="font-bold uppercase text-sm">{{slotProps.item.justification}}</div>
          <div class="text-gray-600 text-sm"> {{$h.formatDate(slotProps.item.createdAt,'DD MMM YYYY HH:mm')}} </div>
        </template>
      </Timeline>
    </div>
  </section>
</template>

<script>
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import pedidoBuscarService from '../../../../services/pedidoBuscarService'
import Timeline from 'primevue/timeline'

export default {
  name: 'History',
  components: {
    Timeline
  },
  setup () {
    const route = useRoute()
    const order = ref({
      id: null,
      details: [],
      states: []
    })
    const getOrder = computed(() => {
      return order.value
    })
    const setOrder = (value) => {
      order.value = value
    }
    const getStates = computed(() => {
      return order.value.states
    })
    const fetchOrder = () => {
      const { id } = route.params
      pedidoBuscarService(id).then(({ data }) => {
        setOrder(data)
      }).catch(err => {
        console.error(err.message)
      })
    }

    onMounted(() => {
      fetchOrder()
    })
    return {
      getOrder,
      getStates
    }
  }
}
</script>
